import { IconProps } from './types';

export function Scene({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.14001 15.0801C6.76001 13.5101 9.38002 13.6501 12 15.5001C14.74 17.4401 17.49 17.5001 20.23 15.6901M8 3L12 11L17 6L22 21H2L8 3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
